export function success(data, info) {
    console.log('DATA: ', data);
    this.$notify({
        title: 'Success',
        message: `${data} has been successfully ${info}`,
        type: 'success'
    });
}

export function warning(data) {
    this.$notify({
        title: 'Warning',
        message: data,
        type: 'warning'
    });
}

export function error(message) {
    this.$notify({
        title: 'Error',
        message: message ? message : 'Something went wrong. Try again',
    });
}

export function forbidden() {
    this.$notify.error({
        title: 'Error',
        message: 'Authorization Token Expired. You have to login again.',
    });
}



// WEBPACK FOOTER //
// ./src/components/Notification/notification.js